import script from "./page-map.vue?vue&type=script&lang=ts&setup=true"
export * from "./page-map.vue?vue&type=script&lang=ts&setup=true"

import "./page-map.vue?vue&type=style&index=0&id=a090f8ea&lang=scss"

const __exports__ = script;

export default __exports__